import React from 'react';

const IntroPisoSpc = () => {
  return (
    <section className="pb-xxl-20">
      <div className="container">
        <div className="row align-items-center">
          {/* Columna de texto */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="mb-1-9 mb-lg-2-5 title-style5">
              <span className="sub-title">Pisos en tendencia 2026</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
                Pisos SPC 
              </h2>
            </div>
            <div className="mb-5">
            <p className="mb-1-6 mb-sm-2-2">
            Los pisos SPC (Stone Plastic Composite) están en tendencia este 2024, gracias a sus diseños modernos, su amplia variedad de colores y texturas, y su facilidad de instalación. 
            Además, cuentan con una base acolchada que reduce el ruido, proporcionando comodidad y durabilidad excepcionales.<br></br>
            El Piso SPC está compuesto por piedra caliza y polímeros (PVC). Esta tecnología innovadora ofrece múltiples ventajas, entre las que destacan:
            </p>

              {/* Tarjetas */}
              <Tarjeta
                titulo="Resistencia al agua y a la humedad"
                descripcion="Son impermeables, lo que los hace ideales para áreas húmedas."
                delay="200ms"
              />
              <Tarjeta
                titulo="Durabilidad "
                descripcion="Ofrecen alta resistencia al desgaste y mayor durabilidad."
                delay="400ms"
              />
              <Tarjeta
                titulo="Resistencia al impacto"
                descripcion="Tienen la capacidad de absorber golpes sin sufrir daños."
                delay="600ms"
              />
            </div>
            <a
              href="contacto-decototal"
              className="butn-style7 rounded wow fadeInUp"
              data-wow-delay="400ms"
            >
              Cotiza Ahora
            </a>
          </div>
          {/* Columna de imagen */}
          <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-lg-0">
            <div className="extra-style-01">
              <img
                className="rounded"
                src="/assets/img/productos/pisos-spc/piso-spc-tv-intro.jpg"
                alt="pisos spc oficina"
              />
              <div className="image-shape1">
                <img
                  className="d-none d-md-block"
                  src="/assets/img/productos/pisos-spc/piso-spc-lq6190-9-muestra.jpg"
                  alt="pisos spc sala"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Tarjeta = ({ titulo, descripcion, delay }) => {
  return (
    <div className={`card card-style21 border-0 wow fadeInUp`} data-wow-delay={delay}>
      <div className="d-flex">
        <span className="card-icon">
          <i className="fa-solid fa-check"></i>
        </span>
        <div className="card-content">
          <h5 className="card-title">{titulo}</h5>
          <p className="card-disc w-lg-85 w-xl-100">{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default IntroPisoSpc;

